import { colorFactory } from "../color-factory";

const transparentColor = colorFactory({
    hue: 0,
    saturation: 0,
    light: 1,
    alpha: 0.000001,
});

export { transparentColor };
